import Section from '../shared/Section';
import PriceAutomation from './PriceAutomationPage/PriceAutomation';
import { SkuStatusForm } from './SkuStatusForm/SkuStatusForm';

import { ApiAvailableStore } from '../types/enums/store.enum';

export const ApplePriceAutomationPage = () => {
    return (
        <>
            <Section title={'Apple Connect Price Automation'}>
                <PriceAutomation store={ApiAvailableStore.APPLE} />
            </Section>
            <Section title={'Apple Connect SKU Status'}>
                <SkuStatusForm store={ApiAvailableStore.APPLE} />
            </Section>
        </>
    );
};
